import { RedirectButtonProps } from 'modules/queryBuilder/contexts';
import { Open16 } from 'ui/icons/aurora/16px/Open16';
import { noop } from 'utils/noop';
import { Tooltip } from 'ui/tooltip/Tooltip';
import { BUTTON_VARIANTS } from 'ui/button';
import { QueryBuilderIconButton } from './QueryBuilderIconButton';

export const DATA_TEST = {
  button: 'redirect-button',
};

/**
 * A button that redirects to a new link or opens a takeover.
 * This button should typically be used for QueryBuilderSelectWithButton.
 * If link is provided use link othewise use button onClick instead
 */

export const RedirectButton = ({
  link,
  tooltipContent,
  onClick = noop,
  ...props
}: RedirectButtonProps) => {
  const onRedirectLink = () => window.open(link, '_blank');
  const onIconClick = link ? onRedirectLink : onClick;
  return (
    <Tooltip tooltipContent={tooltipContent} isEnabled={!!tooltipContent}>
      <QueryBuilderIconButton
        {...props}
        onClick={onIconClick}
        isDisabled={false}
        dataTest={DATA_TEST.button}
        Icon={Open16}
        variant={BUTTON_VARIANTS.GHOST}
      />
    </Tooltip>
  );
};
